import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RemoteDiagnosticsVddGenericStructure } from '@vi-iot/client';

@Component({
  selector: 'app-vdd-ip-address-readonly',
  templateUrl: './vdd-ip-address-readonly.component.html',
  styleUrls: ['./vdd-ip-address-readonly.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddIpAddressReadonlyComponent {
  @Input() structureArray: RemoteDiagnosticsVddGenericStructure[];
}
